import React, { useState, useEffect } from 'react';
import { Button, ArrowUpIcon } from '@ag1/ui';
import clsx from 'clsx';
import { BlogSettingsResult } from 'types/studio/blog';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import styles from './ToTopButton.module.scss';

interface ToTopButtonProps {
  toTopButton: string;
}

type Props = ToTopButtonProps & Pick<BlogSettingsResult, 'theme'>;

export const ToTopButton = ({ toTopButton, theme }: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;

      if (currentScrollTop < lastScrollTop && currentScrollTop > 0) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      setLastScrollTop(currentScrollTop);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollTop]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Button
      size="medium"
      rounded
      variant="outline"
      theme={theme}
      className={clsx(styles.button, getThemeCSSClass(theme), isVisible ? styles.visible : '')}
      icon={<ArrowUpIcon />}
      iconPosition="left"
      onClick={scrollToTop}>
      {toTopButton}
    </Button>
  );
};
